import { TranslationType } from "../types";
import { dashboard } from "./zh/dashboard";
import { landing } from "./zh/landing";
import { story } from "./zh/story";
import { common } from "./zh/common";
import { settings } from "./zh/settings";
import { auth } from "./zh/auth";
import { navigation } from "./zh/navigation";
import { profile } from "./zh/profile";
import { errors } from "./zh/errors";


export const zh: TranslationType = {
  ...dashboard,
  ...landing,
  ...story,
  ...common,
  ...settings,
  ...auth,
  ...navigation,
  ...profile,
  ...errors
};
